export default function ReviewStep({ formData }) {

  return (
    <div className="space-y-8">

      {/* HEADER */}
      <div>
        <h2 className="text-2xl font-semibold">
          Vérification finale
        </h2>
        <p className="text-gray-500 mt-1">
          Vérifiez les informations avant de créer votre établissement
        </p>
      </div>

      {/* GRID */}
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">

        {/* INFORMATIONS */}
        <div className="bg-gray-50 rounded-2xl p-5 space-y-2">
          <h3 className="font-semibold mb-2">Informations</h3>

          <p><span className="text-gray-500">Nom :</span> {formData.name || "-"}</p>
          <p><span className="text-gray-500">Type :</span> {formData.type || "-"}</p>
          <p><span className="text-gray-500">Île :</span> {formData.island || "-"}</p>
          <p><span className="text-gray-500">Ville :</span> {formData.city || "-"}</p>
          <p><span className="text-gray-500">Adresse :</span> {formData.adress || "-"}</p>
        </div>

        {/* PRIX */}
        <div className="bg-gray-50 rounded-2xl p-5 space-y-2">
          <h3 className="font-semibold mb-2">Prix</h3>

          <p>
            <span className="text-gray-500">Prix minimum :</span>{" "}
            {formData.cheapestPrice
              ? `${Number(formData.cheapestPrice).toLocaleString()} € / nuit`
              : "-"}
          </p>
        </div>

      </div>

      {/* DESCRIPTION */}
      <div className="bg-gray-50 rounded-2xl p-5">
        <h3 className="font-semibold mb-2">Description</h3>
        <p className="text-gray-600">
          {formData.desc || "Aucune description"}
        </p>
      </div>

      {/* ÉQUIPEMENTS */}
      <div className="bg-gray-50 rounded-2xl p-5">
        <h3 className="font-semibold mb-3">Équipements</h3>

        {formData.equipments.length > 0 ? (
          <div className="flex flex-wrap gap-2">
            {formData.equipments.map((item, index) => (
              <span
                key={index}
                className="px-3 py-1 bg-green-100 text-green-700 rounded-full text-sm"
              >
                {item}
              </span>
            ))}
          </div>
        ) : (
          <p className="text-gray-500 text-sm">
            Aucun équipement sélectionné
          </p>
        )}
      </div>

      {/* PHOTOS */}
      <div>
        <h3 className="font-semibold mb-3">Photos</h3>

        {formData.photos.length > 0 ? (
          <div className="grid grid-cols-2 md:grid-cols-3 gap-4">
            {formData.photos.map((photo, index) => (
                <img
                    key={photo.id}
                    src={photo.url}
                    alt=""
                    className="w-full h-32 object-cover rounded-xl"
                />
                ))}
          </div>
        ) : (
          <p className="text-gray-500 text-sm">
            Aucune photo ajoutée
          </p>
        )}
      </div>

      {/* PMS */}
      {formData.pms && (
        <div className="bg-gray-50 rounded-2xl p-5">
          <h3 className="font-semibold mb-2">Système de réservation</h3>

          <p>
            <span className="text-gray-500">API URL :</span>{" "}
            {formData.pms.apiUrl || "-"}
          </p>

          <p>
            <span className="text-gray-500">API Key :</span>{" "}
            {formData.pms.apiKey ? "••••••••••" : "-"}
          </p>
        </div>
      )}

      {/* WARNING */}
      <div className="bg-yellow-50 border border-yellow-200 rounded-xl p-4 text-sm text-yellow-700">
        ⚠️ Vérifiez bien vos informations. Vous pourrez les modifier plus tard depuis votre dashboard.
      </div>

    </div>
  );
}